import { Component, OnInit, ViewChild, TemplateRef, Input } from '@angular/core';
import { IEpGridModel, EpEventService, IEpGridSelectionOptions, EpGridEvent, IEpComponentEventArg } from '@epicor/kinetic';
import { BistrackConfig, CustomEvents, PageNames } from 'ep-bt-controls';
import { FieldAgentClient } from 'ep-bt-field-agent-proxy';
import { Router } from '@angular/router';
import { EpbtFaProductService } from '../../services/epbt-fa-product.service';
import { EpbtFaQuickPurchaseService } from '../../services/epbt-fa-quick-purchase.service';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { EpbtFaSortService } from '../../services/epbt-fa-sort.service';

declare var $: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-quick-purchase-selected-product-grid',
  templateUrl: './epbt-fa-quick-purchase-selected-product-grid.component.html',
  styleUrls: ['./epbt-fa-quick-purchase-selected-product-grid.component.scss']
})
export class EpbtFaQuickPurchaseSelectedProductGridComponent implements OnInit {
  products: any;
  public gridModel: IEpGridModel;
  bistrackSettings: any;
  currency: string;
  webTrackUser: any;
  branchId: number;


  @Input() deleteItemFlag = false;

  @ViewChild('removeTemplate', { static: true }) removeTemplate: TemplateRef<any>;
  @ViewChild('quantityTemplate', { static: true }) quantityTemplate: TemplateRef<any>;

  constructor(private client: FieldAgentClient, private router: Router, private config: BistrackConfig,
    public epEvent: EpEventService, private productService: EpbtFaProductService,
    private faQuickPurchaseService: EpbtFaQuickPurchaseService,
    private fieldAgentService: EpbtFieldAgentService, private sortService: EpbtFaSortService) { }

  ngOnInit() {
    this.fieldAgentService.getBisTrackSetting((bistrackSettings: any) => {
      this.bistrackSettings = bistrackSettings;
      // this.currency = this.bistrackSettings.baseCurrency.symbol;
      this.gridModel = this.getGridModel();
      // this.faQuickPurchaseService.prepareData(false);
      // if (this.faQuickPurchaseService.selectedProductsForBinding.length > 0) {
      this.gridModel.data = this.faQuickPurchaseService.selectedProductsForBinding;

      // }
    });
  }



  getGridModel(): IEpGridModel {
    const selectionOptions: IEpGridSelectionOptions = {
      selectByField: 'productId',
      selectedKeys: [],
    };
    const model: IEpGridModel = {
      resizable: false,
      reorderable: false,
      groupable: false,
      filterable: false,
      scrollable: 'scrollable',
      rowHeight: 20,
      height: this.getHeight(),
      sortable: true,
      selectionOptions: selectionOptions,
      columns: [
        { field: 'product.productId', title: '', width: 30, hidden: true },
        { field: 'product.productCode', title: 'CODE', width: 30, hidden: false },
        { field: 'product.description', title: 'DESCRIPTION', width: 30, hidden: false },
        { field: 'quantity', title: 'QUANTITY', width: 30, hidden: false, cellTemplate: this.quantityTemplate },
        { field: 'inputperCode', title: 'UOM', width: 30, hidden: false },
        { field: 'lineNumber', title: 'LINE', width: 30, hidden: false },
        { title: 'DELETE', width: 30, hidden: false, class: 'ep-color-red', cellTemplate: this.removeTemplate }
      ],
      epOnComponentEvent: (eventArg: IEpComponentEventArg) => {
        if (eventArg.eventId == 'epOnCellClick' && eventArg.event && eventArg.event.type == 'click') {
          if (eventArg.event.column.displayTitle != 'DELETE') {
            // if (this.deleteItemFlag) {
            this.navigateTo(eventArg.event.dataItem);
            // } else {
            // DoNothing
            // }

          }
        }
      },
    };
    $(window).resize(() => {
      this.updateGrid();
    });
    return model;
  }

  // grid height calculation start

  updateGrid() {
    const calHeight = this.getHeight();
    this.gridModel.height = calHeight;
  }


  getHeight(): number {
    const height = $(window).outerHeight() - 399; // 399
    const width = parseInt($('body').width());

    if (width > 250 && width < 1023) {
      // mobile and ipad
      return 400;
    }
    return height;

  }
  // grid height calculation end

  updateGridData() {
    // this.faQuickPurchaseService.prepareData(flag);
    this.gridModel.data = this.faQuickPurchaseService.selectedProductsForBinding.slice();
  }

  onCardClick(model) {
    if (!this.deleteItemFlag) {
      this.navigateTo(model);
    }
  }

  navigateTo(args: any) {
    this.productService.fromPage = PageNames.QuickPurchaseProductSearch; //
    this.faQuickPurchaseService.isNegotiationEdit = true;
    this.faQuickPurchaseService.quickPurchaseLine = args;
    this.productService.selectedProductItem = this.faQuickPurchaseService.selectedProductsForBinding.find(c => c.product.productId == args.product.productId).product;
    this.sortService.previousProductSearchForTransferOrOrder = null;
    this.router.navigate(['/home/product/details', args.product.productId]);
  }

  onRemove(dataItem: any) {
    const index = this.faQuickPurchaseService.selectedProductsForBinding.findIndex(c => c.lineNumber == dataItem.lineNumber);
    if (index >= 0) {
      let lineNum = 0;
      this.faQuickPurchaseService.selectedProductsForBinding.splice(index, 1);
      this.faQuickPurchaseService.selectedProductsForBinding.forEach(item => item.lineNumber = ++lineNum);
      this.gridModel.data = this.faQuickPurchaseService.selectedProductsForBinding.slice();
    }
  }
}

